import { createReducer } from "@reduxjs/toolkit";
import { GenericUpdate } from "../actions";
import { IAdminSessionDataDto } from '../../shared/dto/session-data.dto';
import { IGetAllProvidersDto } from "../../shared/dto/login-user.dto";


interface InitialState {
    session_data?: IAdminSessionDataDto,
    force_redirect?: string,
    all_providers?: IGetAllProvidersDto
}


const initialState : InitialState = {
    session_data: undefined,
    force_redirect: undefined
} 

export const genericReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(GenericUpdate, (state, action) => {
            if(action.payload.type === 'replace_and_update') {
                //@ts-ignore
                state[action.payload.field] = action.payload.values;
            }
            if(action.payload.type === 'reset') {
                //@ts-ignore
                state[action.payload.field] = undefined;
            }
        })
})